import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/App.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BailoutToCSR"] */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadCss"] */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-questrial\",\"weight\":\"400\"}],\"variableName\":\"opensans\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/globals.css");
